import React from 'react';
import { Container, Typography, Paper, Button, Box, List, ListItem, ListItemIcon, Avatar, ListItemText, Chip } from '@mui/material';
import { AccessTime, ArrowBack, School, Star, Timeline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StudentActivities: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Button startIcon={<ArrowBack />} onClick={() => navigate('/student-dashboard')} sx={{ mb: 3 }}>
                Back to Dashboard
            </Button>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                <AccessTime sx={{ fontSize: 40, color: '#57606f' }} />
                <Typography variant="h4" fontWeight="bold">Mission Log (Activities)</Typography>
            </Box>

            <Paper sx={{ p: 4, borderRadius: 5, bgcolor: '#fff', mb: 5 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>Recent History</Typography>
                <List>
                    <ListItem sx={{ px: 0, py: 2, borderBottom: '1px dashed #dfe4ea' }}>
                        <ListItemIcon>
                            <Avatar sx={{ bgcolor: '#e1f5fe', color: '#03a9f4' }}>
                                <School fontSize="small" />
                            </Avatar>
                        </ListItemIcon>
                        <ListItemText
                            primary={<Typography fontWeight="bold">Completed topic "Quadratic Formulas"</Typography>}
                            secondary="Mathematics • 2 hours ago"
                        />
                        <Chip label="+10 Pts" size="small" sx={{ bgcolor: '#e1f5fe', color: '#03a9f4', fontWeight: 'bold' }} />
                    </ListItem>

                    <ListItem sx={{ px: 0, py: 2, borderBottom: '1px dashed #dfe4ea' }}>
                        <ListItemIcon>
                            <Avatar sx={{ bgcolor: '#fff9c4', color: '#fbc02d' }}>
                                <Star fontSize="small" />
                            </Avatar>
                        </ListItemIcon>
                        <ListItemText
                            primary={<Typography fontWeight="bold">Scored 100% on "Motion Quiz"</Typography>}
                            secondary="Physics • Yesterday"
                        />
                        <Chip label="+50 Pts" size="small" sx={{ bgcolor: '#fff9c4', color: '#fbc02d', fontWeight: 'bold' }} />
                    </ListItem>

                    <ListItem sx={{ px: 0, py: 2, borderBottom: '1px dashed #dfe4ea' }}>
                        <ListItemIcon>
                            <Avatar sx={{ bgcolor: '#ffebee', color: '#ef5350' }}>
                                <Timeline fontSize="small" />
                            </Avatar>
                        </ListItemIcon>
                        <ListItemText
                            primary={<Typography fontWeight="bold">Promoted to Corporal</Typography>}
                            secondary="Rank Up • 2 days ago"
                        />
                        <Chip label="Rank Up" size="small" sx={{ bgcolor: '#ffebee', color: '#ef5350', fontWeight: 'bold' }} />
                    </ListItem>
                    <ListItem sx={{ px: 0, py: 2 }}>
                        <ListItemIcon>
                            <Avatar sx={{ bgcolor: '#e8f5e9', color: '#4caf50' }}>
                                <School fontSize="small" />
                            </Avatar>
                        </ListItemIcon>
                        <ListItemText
                            primary={<Typography fontWeight="bold">Registered for "World History"</Typography>}
                            secondary="Course Enrollment • 3 days ago"
                        />
                    </ListItem>
                </List>
            </Paper>
        </Container>
    );
};

export default StudentActivities;
